<template>
  <FlotoFormItem
    :label="columnName"
    :rules="required ? 'required|nonzero' : undefined"
    :label-col="{ xxl: 3, xl: 4, lg: 4 }"
    :wrapper-col="{ xxl: 9, xl: 8, lg: 8 }"
  >
    <FlotoDropdownPicker
      v-model="internalValue"
      searchable
      as-input
      :options="columnOptions"
    />
  </FlotoFormItem>
</template>

<script>
export default {
  name: 'ColumnMappingPicker',
  model: { event: 'change' },
  props: {
    value: { type: String, default: undefined },
    required: { type: Boolean, default: false },
    columnName: { type: String, required: true },
    columnOptions: { type: Array, required: true },
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      },
    },
  },
}
</script>
